import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { format } from 'date-fns';
import { dateFormats } from '../../../../constants';
import {
  putSetPointsValue,
  getSetPointsHistoric,
} from '../../../../services/api';
import { notifyError, notifySuccess } from '../../../../utils';
import {
  ChangeSetPointsValueConfirmation,
  Input,
  Loader,
} from '../../../../components';
import { icons } from '../../../../assets';
import SetPointCard from './card-set-point';
import * as s from './styled-cards-set-points';

const CardsVariaveis = ({ setPoints, thingId, thingName }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [filterHistoric, setFilterHistoric] = useState(false);
  const [historic, setHistoric] = useState([]);
  const [loadingHistoric, setLoadingHistoric] = useState(false);
  const [showSaveSetpoints, setShowSaveSetpoints] = useState(false);
  const [setpointValues, setSetpointValues] = useState({});

  const changeSetPointValue = () => {
    let cont = 0;
    const valuesArray = Object.entries(setpointValues);
    valuesArray.forEach(([key, { value, name }]) => {
      putSetPointsValue({
        setpointName: name,
        setpointId: Number(key),
        value: Number(value),
        thingId: Number(thingId),
        thingName,
      })
        .then(() => {
          cont += 1;
          if (cont && cont === valuesArray.length) {
            notifySuccess('Setpoints editados com sucesso');
            setShowSaveSetpoints(false);
          }
        })
        .catch(() => {
          cont = false;
          notifyError('Erro ao editar os setpoints');
        });
    });
  };

  useEffect(() => {
    if (open.id) {
      setLoadingHistoric(true);
      getSetPointsHistoric(thingId, parseInt(open.setpoint.id, 10))
        .then((resp) => {
          setHistoric(resp.data);
        })
        .catch(() =>
          notifyError('Erro ao buscar o histórico de setpoint da thing')
        )
        .finally(() => setLoadingHistoric(false));
    }
  }, [open, thingId]);

  return (
    <>
      <s.Container>
        {setPoints.map((point) => {
          return (
            <SetPointCard
              variavel={point}
              changeSetPointValue={changeSetPointValue}
              value={setpointValues[point.setpoint.id]}
              openModal={() => setOpen(point)}
              changeValue={(id, value) => {
                if (!showSaveSetpoints) setShowSaveSetpoints(true);
                setSetpointValues({ ...setpointValues, [id]: value });
              }}
            />
          );
        })}
      </s.Container>
      {open.id && (
        <Modal
          style={customStyles}
          isOpen
          onRequestClose={() => {
            setOpen({});
            setFilterHistoric('');
          }}
        >
          <s.CloseButton onClick={() => setOpen({})} />
          <s.Line>
            <span>Histórico</span>
            <Input
              width="260px"
              height="20px"
              value={search}
              placeholder="Pesquise um usuário ou temperatura"
              onChange={(e) => historic.length && setSearch(e.target.value)}
            />
            <s.Line style={{ width: 82 }}>
              <s.Tag
                clickable
                onClick={() => {
                  if (filterHistoric === 'company') setFilterHistoric(false);
                  else setFilterHistoric('company');
                }}
                style={{ marginRight: 10, height: 11 }}
                color="darkblue"
              />
              <s.Tag
                clickable
                onClick={() => {
                  if (filterHistoric === 'customer') setFilterHistoric(false);
                  else setFilterHistoric('customer');
                }}
                style={{ height: 11 }}
                color="orange"
              />
            </s.Line>
          </s.Line>
          {loadingHistoric ? (
            <Loader />
          ) : historic.length ? (
            <s.HistoricGraphWrapper>
              <s.HistoricInfo>
                <s.Column style={{ justifyContent: 'space-evenly' }}>
                  <s.Title>{open.setpoint.label}</s.Title>
                  <s.Level>High</s.Level>
                  <s.ElevatedValue
                    type="number"
                    value={open.value}
                    onChange={() => null}
                  />
                  <img
                    style={{ width: 15, height: 15 }}
                    src={icons.MonitorCardiaco}
                    alt=""
                  />
                </s.Column>
              </s.HistoricInfo>
              <s.HistoricTimelineWrapper>
                {historic
                  .filter(({ user }) => {
                    if (filterHistoric) {
                      if (user[filterHistoric] === filterHistoric) {
                        return true;
                      }
                      return false;
                    }
                    return true;
                  })
                  .map((info) => (
                    <s.HistoricTimelineCell company={info.user.company}>
                      <s.HistoricCellColumn>
                        <h3>
                          {format(new Date(info.date), 'dd-MM-yyyy')} às{' '}
                          {format(new Date(info.date), dateFormats.TIME)}
                        </h3>
                        <span>
                          De {info.fromValue} para {info.toValue}
                        </span>
                        <label>{info.user.name}</label>
                      </s.HistoricCellColumn>
                      <s.HistoricCellTag company={info.user.company} />
                    </s.HistoricTimelineCell>
                  ))}
              </s.HistoricTimelineWrapper>
            </s.HistoricGraphWrapper>
          ) : (
            <label>Não há informações a serem exibidas</label>
          )}
        </Modal>
      )}
      {showSaveSetpoints && (
        <ChangeSetPointsValueConfirmation
          onCancel={() => {
            setShowSaveSetpoints(false);
            setSetpointValues({});
          }}
          onConfirm={() => changeSetPointValue()}
        />
      )}
    </>
  );
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    height: '70%',
    position: 'absolute',
    display: 'grid',
    gridTemplateRows: '1fr 8fr',
    rowGap: 16,
    borderRadius: 16,
    zIndex: 102,
  },

  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.6)',
    zIndex: 102,
  },
};

export default CardsVariaveis;
